
  export default {
    middleware: ['providers', 'searches/current', 'products/current', 'breadcrumbs', 'jumbotron', 'meta-tags'],
    meta: {
      category: 'banking',
      jumbotronScope: 'compare-current-accounts.show',
      metaTagOptions: { image: 'currents' },
      product: 'currents',
      searchPath: 'banking/current_searches'
    },
    computed: {
      current () {
        return this.$store.state.products.current;
      }
    }
  };
